import React from 'react';

import { ChocoSelect } from '../../../../../components/FormComponents';
import { TableHeader } from '../../../../../components/Table';

interface TableControlsProps {
  searchValue: string;
  pageSize: number;
  onSearchChange: (value: string) => void;
  onPageSizeChange: (size: number) => void;
}

export const TableControls: React.FC<TableControlsProps> = ({
  searchValue,
  pageSize,
  onSearchChange,
  onPageSizeChange,
}) => {
  const pageSizeOptions = [
    { value: '10', label: '10' },
    { value: '25', label: '25' },
    { value: '50', label: '50' },
    { value: '100', label: '100' },
  ];

  return (
    <TableHeader
      searchValue={searchValue}
      onSearchChange={onSearchChange}
      searchPlaceholder="Search by name, phone, email, or ID..."
    >
      <div className="w-44">
        <ChocoSelect
          options={pageSizeOptions}
          value={pageSize.toString()}
          onSelectionChange={(selectedValue) => {
            if (selectedValue) {
              onPageSizeChange(parseInt(selectedValue, 10));
            }
          }}
          size="sm"
          aria-label="Select page size"
          showDescriptions={false}
        />
      </div>
    </TableHeader>
  );
};
